import type { VehicleTyreLayout } from '@chukua/common';
import { TyreDiagramPanel } from '../../../../reference-data/features/tyre-layouts/public/TyreDiagramPanel';
import { toDiagramAxles } from './vehicle-diagram-axles';

interface VehicleTyreDiagramProps {
  layout: VehicleTyreLayout;
  selectedCode?: string | null;
  onSelect?: (code: string) => void;
  className?: string;
}

/** A truck's or trailer's own vehicle in 3D, drawn from its current tyre layout and carrying its registration and its own paint, for every tyre screen that names a position. */
export function VehicleTyreDiagram({ layout, selectedCode, onSelect, className }: VehicleTyreDiagramProps) {
  return (
    <TyreDiagramPanel
      className={className}
      subjectKind={layout.vehicleKind === 'truck' ? 'truck_class' : 'trailer_type'}
      bodyStyle={layout.bodyStyle}
      axles={toDiagramAxles(layout)}
      selectedCode={selectedCode}
      onSelect={onSelect}
      registration={layout.registration}
      color={layout.color}
    />
  );
}
